import AxiosPermisos  from '@/services/axiosPermisos'

// ## RUTA
const route = '/airlines'

// ## METODOS
const airlineService = () => AxiosPermisos.get(route, true, 'v2')

export {
  airlineService
}